import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { WhatToAskAboutImage } from '../Images';
import * as s from './SidebarTips.css';

/**
 * Карточка "О чем спросить" в сайдбаре
 */
export const SidebarWhatToAskAboutTip = () => {
  const items = [
    'Спросите о юридических тонкостях в сделках с недвижимостью',
    'Расскажите о своей ситуации и получите советы от профессионалов рынка',
    'Попросите оценить стоимость вашего объекта',
  ];

  return (
    <SidebarTip title="О чём спросить" image={<WhatToAskAboutImage />}>
      <ul className={s['items-wrapper']}>
        {items.map((item, index) => (
          <li key={index}>
            <UIText1>{item}</UIText1>
          </li>
        ))}
      </ul>
    </SidebarTip>
  );
};
